/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react';

import { usePropertyListing } from 'src/common/stores/contexts';

import { UitkSpacing } from 'uitk-react-spacing';
import { UitkText } from 'uitk-react-text';

export const ListingTravelAd: React.FunctionComponent = () => {
  const { sponsoredListing } = usePropertyListing();

  if (!sponsoredListing) {
    return null;
  }

  const { brand, clickRedirectLinkoffTrackingUrl, details, detailsHeadline, logo, vanityUrl } = sponsoredListing;

  return (
    <React.Fragment>
      {detailsHeadline && detailsHeadline !== 'null' && details && details !== 'null' && (
        <React.Fragment>
          <div
            className="uitk-type-200 uitk-type-bold uitk-neutral-700 all-t-padding-one all-b-padding-half"
            data-stid="content-hotel-details-headline"
          >
            {detailsHeadline}
          </div>
          <UitkSpacing padding={{ blockend: 'two' }}>
            <UitkText size={200} className={'pwa-theme--grey-700'} data-stid="content-hotel-details">
              {details}
            </UitkText>
          </UitkSpacing>
        </React.Fragment>
      )}
      {clickRedirectLinkoffTrackingUrl && (
        <React.Fragment>
          {logo && <img className="all-t-margin-two all-b-margin-two all-r-margin-two" src={logo} alt={brand ? brand : vanityUrl} />}
          <a className="uitk-type-200">{vanityUrl}</a>
        </React.Fragment>
      )}
    </React.Fragment>
  );
};
ListingTravelAd.displayName = 'ListingTravelAd';
